import type { FilterOption } from '@/components/FilterMenu'
import { FilterMenu } from '@/components/FilterMenu'
import { Box, HStack, Icon } from '@chakra-ui/react'
import { Check } from 'lucide-react'
import { useTranslation } from 'react-i18next'

interface TagsFilterProps {
  options: FilterOption[]
  selectedTags: FilterOption[]
  setSelectedTags: (tags: FilterOption[]) => void
  setPage: (pageNumber: number | ((prev: number) => number)) => void
}

export function TagsFilter({
  options,
  selectedTags,
  setSelectedTags,
  setPage,
}: TagsFilterProps) {
  const { t } = useTranslation()

  return (
    <div data-testid="tags-filter">
      <FilterMenu
        buttonLabel={t('clusterConfigTable.filters.tags')}
        headerTitle={
          t('components.filterMenu.filterBy', {
            label: t('clusterConfigTable.filters.tags'),
          }) as string
        }
        options={options}
        selectedOption={null} // We're handling multi-select differently
        onOptionChange={(option) => {
          // Handle single option select by toggling it in the array
          const newSelected = [...selectedTags]
          const existingIndex = newSelected.findIndex(
            (tag) => tag.value === option.value,
          )

          if (existingIndex >= 0) {
            // Remove if already selected
            newSelected.splice(existingIndex, 1)
          } else {
            // Add if not selected
            newSelected.push(option)
          }

          setSelectedTags(newSelected)
          setPage(1)
        }}
        isSearchable
        searchFields="both"
        renderMenuItem={(option, _isSelected) => {
          // Check if this option is in our selectedTags array
          const isTagSelected = selectedTags.some(
            (tag) => tag.value === option.value,
          )
          return (
            <HStack>
              {isTagSelected ? <Icon as={Check} /> : <Box width="16px" />}
              <Box fontSize="sm">{option.label}</Box>
            </HStack>
          )
        }}
        autoCloseOnSelect={false}
      />
    </div>
  )
}
